import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeysToArrayPipe } from './enum-to-array.pipe';

@NgModule({
  declarations: [KeysToArrayPipe],
  imports: [CommonModule],
  exports: [KeysToArrayPipe],
})
export class KeysToArrayPipeModule {}
